/** Типы логических операций допустимых при фильтрации. */
export enum DxGridFilterOperationType {
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS'
}
